import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";

/**
 * Celular único no sistema (migrations 240/241). O vendedor não enxerga o
 * contato de outro (RLS da 66), então "de quem é este número" é uma função do
 * banco que devolve só o NOME do dono — nunca o contato.
 */

// Funções da 241 ainda fora de database.generated.ts: cliente sem tipo, como em feed/feedApi.ts.
const sb = supabase as unknown as {
  rpc: (fn: string, args?: Record<string, unknown>) => PromiseLike<{ data: unknown; error: { message?: string } | null }>;
};

export type SituacaoDoCelular =
  | { situacao: "livre" }
  | { situacao: "propria"; dono_nome?: string }
  | { situacao: "outro"; dono_nome: string };

/**
 * `ignorarContatoId`: na edição, o próprio contato não conta. Resposta vazia
 * (função ainda não aplicada no banco) vale como livre — quem decide no fim é
 * o gatilho da 240.
 */
export async function donoDoCelular(
  telefone: string,
  ignorarContatoId?: number | string | null,
): Promise<SituacaoDoCelular> {
  const { data, error } = await sb.rpc("dono_do_celular", {
    p_phone: telefone,
    p_ignorar_contato_id: ignorarContatoId == null ? null : Number(ignorarContatoId),
  });
  if (error) throw new Error(error.message ?? "Não foi possível conferir o celular.");
  const r = (data ?? null) as SituacaoDoCelular | null;
  if (!r || (r.situacao !== "propria" && r.situacao !== "outro")) return { situacao: "livre" };
  return r;
}

export type OrigemDoAviso = "cadastro" | "edicao";

export interface RespostaDoAviso {
  ok: boolean;
  ja_avisado: boolean;
  duplicidade_id?: number;
  gestor_nome?: string | null;
}

/** Botão "Avisar o gestor": abre a ocorrência em Duplicidades e avisa gestor e super admins. */
export async function avisarGestorDuplicidade(
  telefone: string,
  nomeContato: string,
  origem: OrigemDoAviso,
): Promise<RespostaDoAviso> {
  const { data, error } = await sb.rpc("avisar_gestor_duplicidade", {
    p_phone: telefone,
    p_nome_contato: nomeContato,
    p_origem: origem,
  });
  if (error) throw new Error(error.message ?? "Não foi possível avisar o gestor.");
  return (data ?? { ok: true, ja_avisado: false }) as RespostaDoAviso;
}
